import React, {PropsWithChildren} from "react";
import {useTranslation} from "react-i18next";
import {ErrorMessageView} from "./base/ErrorMessageView";

export interface Props {
    isAuthorized: boolean;
}

export const ViewAuthorizationGuard: React.FC<PropsWithChildren<Props>> = ({isAuthorized, children}) => {
    const {t} = useTranslation();

    return isAuthorized ? <>{children}</> : <ErrorMessageView message={t("authorization_guard.error")} />;
};
